package com.rainbowclubs.rainbow.domain.use_cases.events

import com.rainbowclubs.rainbow.data.models.Event
import com.rainbowclubs.rainbow.domain.repositories.EventsRepository

class GetEventByIdUseCase(
    private val eventsRepository: EventsRepository,
) {
    suspend operator fun invoke(eventId: String): Result<Event> {
        return eventsRepository.getEventById(eventId)
    }
}
